import { createNamespacedHelpers } from "vuex-composition-helpers";
const {
  useActions,
  useGetters,
  useMutations,
  useState
} = createNamespacedHelpers("ReferrerStore");
export const useReferrerStoreActions = useActions;
export const useReferrerStoreGetters = useGetters;
export const useReferrerStoreMutations = useMutations;
export const useReferrerStoreState = useState;